module.exports = __webpack_public_path__ + "static/media/Drip_Echo.ec5aa5ba.wav";